import * as fromMapaBase from '../../actions/AdmMapa/mapaBase.actions';


export interface MapaBaseState {
    loaded: boolean;
    loading: boolean;
    mapaBase: { [key: string]: boolean; } | null;
    errorMessage: any | null;
}

export const initialState: MapaBaseState = {
    loaded: false,
    loading: false,
    mapaBase: null,
    errorMessage: null
  };

export function mapaBaseReducer(state = initialState, action: fromMapaBase.mapaBaseAcciones): MapaBaseState {
    switch (action.type) {
        case fromMapaBase.MapaBaseActionTypes.GET_MAPABASE:
            return {
                ...state,
                loading: true,
                errorMessage: null
            };
        case fromMapaBase.MapaBaseActionTypes.GET_MAPABASE_SUCCESS:
            return {
                ...state,
                loading: false,
                loaded: true,
                mapaBase: {...action.mapaBase}
            };
        case fromMapaBase.MapaBaseActionTypes.GET_MAPABASE_FAILURE:
            return {
                ...state,
                loaded: true,
                loading: false,
                errorMessage: {
                    status: action.payload.status,
                    message: action.payload.message,
                    url: action.payload.url
                }
            };
      default: {
        return state;
      }
  }
}
